import { GoogleLogin, googleLogout } from '@react-oauth/google'
import logo from 'assets/logo.svg'
import { googleCredentialAtom } from 'store/atoms'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { parseJwt } from 'utils/jwt'
import { useTailwindBreakpoint } from 'custom-hooks/useTailwindBreakpoint'
import PostManager from 'organisms/PostManager'
import InfoIcon from 'atoms/icons/InfoIcon'
import Image from 'atoms/Image'

async function isTokenValid(credential: string): Promise<boolean> {
  const resp = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${credential}`)
  return resp.status === 200
}

function Home() {
  const [googleCredential, setGoogleCredential] = useAtom(googleCredentialAtom)
  const [email, setEmail] = useState<string>()
  const { breakpoint } = useTailwindBreakpoint()

  useEffect(() => {
    if (!googleCredential?.credential || !isTokenValid(googleCredential.credential)) {
      googleLogout()
      setEmail(undefined)
      return
    }

    const jwt = parseJwt(googleCredential.credential)
    setEmail(jwt.email)
  }, [googleCredential])

  return (
    <>
      <div className='Home'>
        <div className='navbar bg-base-100 justify-between'>
          <div>
            <a href='/'>
              <Image src={logo} className='min-h-14 min-w-14 h-14 w-14 p-2' alt='logo' />
            </a>
            <a className='invisible sm:visible btn btn-ghost text-xl' href='/'>
              Media Generator PlusBox
            </a>
          </div>
          <div
            className='tooltip tooltip-left'
            data-tip={googleCredential ? email : 'Você está deslogado, clique para entrar'}>
            <div className={`flex items-center ${googleCredential ? '' : 'cursor-pointer bg-error p-1 rounded-md'}`}>
              {!googleCredential && (
                <div className='px-4 text-error-content'>
                  <InfoIcon />
                </div>
              )}
              <GoogleLogin
                type={breakpoint === 'xs' ? 'icon' : 'standard'}
                onSuccess={credentialResponse => {
                  setGoogleCredential(credentialResponse)

                  // We have to refresh again after success, because of
                  // https://github.com/MomenSherif/react-oauth/issues/289
                  window.location.reload()
                }}
                onError={() => {
                  setGoogleCredential(null)
                  // googleLogout doesn't work but I'm leaving it here just in case it works in a future dependency release
                  googleLogout()

                  // We have to refresh again after success, because of
                  // https://github.com/MomenSherif/react-oauth/issues/289
                  window.location.reload()
                }}
              />
            </div>
          </div>
        </div>
        <div className='px-6 mt-6'>
          <PostManager />
        </div>
      </div>
    </>
  )
}

export default Home
